// Presentation follows an actual broken, descending tower. Ordinary build hops,
// a successful landing do not count as a collapse.
export function fallIntensity(game){
  if(!game?.breaks||game.status==='won')return 0;
  if(game.traversal&&game.grounded?.(game.top))return 0;
  return Math.max(0,Math.min(1,(-game.player.getLinearVelocity().y-2)/10));
}
